module.exports = __webpack_public_path__ + "img/wechat_code_owner.cdc9bb99.jpg";